import styled from 'styled-components'

import type { TooltipProps } from './Tooltip'
import { Tooltip } from './Tooltip'

const IndicatorWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;

  &:hover {
    cursor: help;
  }
`

export interface InteractiveTooltipProps extends Pick<TooltipProps, 'children' | 'title' | 'onOpenChangeCallback'> {
  className?: string
}

export function InteractiveTooltip({ className, children, ...rest }: InteractiveTooltipProps) {
  return (
    <Tooltip {...rest} interactive placement="bottom" withPortal>
      <IndicatorWrapper className={className}>{children}</IndicatorWrapper>
    </Tooltip>
  )
}
